import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { AppState } from '../../app.service';

export interface DataToShareInterface {
  image: string,
  title: string,
  copy: string,
  buttonCode?: string,
  linkToShare?: string,
  socialNetwork?: string,
  shareAButton?: boolean,
  buttonHtmlLink?: string,
  sharingLink?: string
}

@Injectable()
export class ShareButtonsService {
  private facebookShareUrl: string = 'https://www.facebook.com/sharer/sharer.php?u=';
  private twitterShareUrl: string = 'https://twitter.com/intent/tweet?url=';
  private linkedInShareUrl: string = 'https://www.linkedin.com/sharing/share-offsite/?url=';
  private whatsAppShareUrl: string = 'https://wa.me/?text=';
  private iMessageShareUrl: string = 'sms:/?&body=';
  private buttonShareUri: string;
  private shareModalState: boolean = false;
  private shareModalStateSub = new Subject<boolean>();
  private dataToShare: DataToShareInterface;

  constructor(private appState: AppState) {
    this.buttonShareUri = 'https://pk7napwge5.execute-api.eu-central-1.amazonaws.com/stg/html/button/';
  }

  private windowOpenWithShareLink(link: string) {
    window.open(link, 'pop', 'width=600, height=400, scrollbars=no');
  }

  private encodeURI(uri: string) {
    return encodeURIComponent(uri);
  }

  private shareOnFacebook(uri: string, isButtonToShare: boolean) {
    if (isButtonToShare) {
      uri = `${this.buttonShareUri}${uri}`;
    }

    this.windowOpenWithShareLink(this.facebookShareUrl + this.encodeURI(uri));
  }

  private shareOnTwitter(uri: string, isButtonToShare: boolean) {
    if (isButtonToShare) {
      uri = `${this.buttonShareUri}${uri}`;
    }

    this.windowOpenWithShareLink(this.twitterShareUrl + this.encodeURI(uri));
  }

  private shareOnLinkedIn(uri: string, isButtonToShare: boolean) {
    if (isButtonToShare) {
      uri = `${this.buttonShareUri}${uri}`;
    }

    this.windowOpenWithShareLink(this.linkedInShareUrl + this.encodeURI(uri));
  }

  private shareOnWhatsApp(uri: string, isButtonToShare: boolean) {
    if (isButtonToShare) {
      uri = `${this.buttonShareUri}${uri}`;
    }

    this.windowOpenWithShareLink(this.whatsAppShareUrl + this.encodeURI(uri));
  }

  private shareOnIMessage(uri: string, isButtonToShare: boolean) {
    if (isButtonToShare) {
      uri = `${this.buttonShareUri}${uri}`;
    }

    this.windowOpenWithShareLink(this.iMessageShareUrl + this.encodeURI(uri));
  }

  public processSharing(sharingData: DataToShareInterface) {
    switch (sharingData.socialNetwork) {
      case 'Facebook':
        if (sharingData.linkToShare) {
          this.shareOnFacebook(`${sharingData.linkToShare}/fb`, false);
        } else {
          this.shareOnFacebook(`${sharingData.buttonHtmlLink}/fb`, true);
        }

        break;
      case 'Twitter':
        if (sharingData.linkToShare) {
          this.shareOnTwitter(`${sharingData.linkToShare}/tw`, false);
        } else {
          this.shareOnTwitter(`${sharingData.buttonHtmlLink}/tw`, true);
        }

        break;
      case 'LinkedIn':
        if (this.sharingData.linkToShare) {
          this.shareOnLinkedIn(`${sharingData.linkToShare}/li`, false);
        } else {
          this.shareOnLinkedIn(`${sharingData.buttonHtmlLink}/li`, true);
        }

        break;
      case 'WhatsApp':
        this.shareOnWhatsApp(`${sharingData.buttonHtmlLink}/wa`, true);

        break;
      case 'iMessage':
        this.shareOnIMessage(`${sharingData.buttonHtmlLink}/im`, true);

        break;
      default:
        break;
    }
  }

  public toggleShareModal(dataToShare: DataToShareInterface, shareModalState: boolean) {
    this.dataToShare = dataToShare;
    this.shareModalState = shareModalState;
    this.shareModalStateSub.next(this.shareModalState);
  }

  public get getShareModalState(): Observable<any> {
    return this.shareModalStateSub.asObservable();
  }

  public get sharingData(): DataToShareInterface {
    return this.dataToShare;
  }
}



// WEBPACK FOOTER //
// ./src/app/global/shareButtons/shareButtons.service.ts